export default __webpack_public_path__ + "static/media/tick-check.ac76823c.svg";